/**
 * 使用DeepSeek模型通过OpenRouter API增强/润色文本
 * @param {string} text - 需要润色的原始文本
 * @returns {Promise<{success: boolean, data: string, error: string|null}>}
 */
const enhanceText = async (text) => {
  // 定义API Key池
  const apiKeys = [
    "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", // 原始Key
    "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", // 新Key 1
    "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", // 新Key 2
    "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",  // 新Key 3
    "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", // 新Key 4
    "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", // 新Key 5
    "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", // 新Key 6
    "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", // 新Key 7
    "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", // 新Key 8
    "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"  // 新Key 9
  ];

  // 随机选择一个API Key
  const randomKey = apiKeys[Math.floor(Math.random() * apiKeys.length)];
  
  try {
    // 获取当前域名作为Referer值，确保只使用ASCII字符
    let referer = "https://hugtub.app";
    try {
      referer = window.location.origin;
      // 确保是有效的ASCII值
      referer = encodeURI(referer);
    } catch (e) {
      console.warn("无法获取当前域名，使用默认值");
    }
    
    // 先检测文本类型和特征
    const isShort = text.length < 50;
    const mightBeStory = text.includes('...') || 
                           /遗嘱|故事|谜题|谜团|线索|富翁|宝藏|秘密|古老|神秘|传说/.test(text);
    const mightBePuzzle = /谜语|猜谜|拼图|谜底|迷宫|解谜|谜团|北走|东走|向北|线索|步数|遗嘱/.test(text);
    
    // 根据文本特征调整提示词
    let enhanceType = "";
    let enhanceStyle = "";
    
    if (mightBeStory || mightBePuzzle) {
      enhanceType = "故事型/谜题型文本";
      enhanceStyle = `
        * 如果是故事开头，请增强其神秘感和吸引力，扩展故事背景和细节
        * 如果是谜题，保持或增强其悬念，同时确保不删除任何线索信息
        * 特别关注可能包含线索的数字、方向、标志物或地点描述
        * 不要简化文本，保留原文中所有暗示和提示，并可适当强化这些元素
        * 如果包含悬念，请确保扩展后保持或强化这种悬念
      `;
    } else {
      enhanceType = "普通文本";
      enhanceStyle = `
        * 增强文本的表现力和生动度，使其更加流畅自然
        * 适当扩展文本内容，丰富细节和描述
        * 保持原有的专业术语和关键信息不变
        * 提高语言的优雅度和吸引力
      `;
    }
    
    if (isShort) {
      enhanceStyle += `\n* 文本较短，请务必保留所有原始信息，适当扩展而不是简化`;
    }
    
    // 构建请求体
    const requestBody = {
      model: "deepseek/deepseek-chat-v3-0324:free", // 使用DeepSeek模型
      messages: [
        {
          role: "system",
          content: `你是专业的文章润色助手，擅长增强各类文本，特别是故事和谜题类型的内容。你现在收到的是一段${enhanceType}，需要你按照以下规则进行润色和增强：

1. 严格保持原文的核心意思、主题和关键信息
2. 增强文本的表现力和生动度，保持或提升文本的吸引力
3. 原文中的每个关键信息点必须保留，不得删减重要内容
4. 扩展适当细节来增强文本魅力，但决不能缩减内容
5. 原文中不完整或带有"..."的部分，应视作需要你扩展和完善的提示

针对此文本的特殊处理要点：
${enhanceStyle}

处理要求：
* 直接返回润色后的完整文本，不要添加任何解释、引号或额外标记
* 不要表明你是AI或正在执行润色任务
* 确保返回的文本比原文更加生动、流畅和吸引人
* 输出格式需保持与原文一致，不要添加额外的格式或结构元素
* 禁止使用任何形式的加粗语法（不要使用**文字**样式的加粗标记）
* 不要在回答的开头添加空行，直接从第一行开始提供内容`
        },
        {
          role: "user",
          content: text
        }
      ],
      max_tokens: 2000,
      temperature: 0.7 // 提高创造性，但不至于过度发散
    };
    
    console.log("发送API请求:", JSON.stringify(requestBody, null, 2));
    
    const response = await fetch(
      "https://openrouter.ai/api/v1/chat/completions",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${randomKey}`,
          "Content-Type": "application/json",
          "HTTP-Referer": referer,
          "X-Title": "HugTub"
        },
        body: JSON.stringify(requestBody)
      }
    );

    const responseText = await response.text();
    console.log("API原始响应文本:", responseText);
    
    // 尝试解析响应为JSON
    let data;
    try {
      data = JSON.parse(responseText);
    } catch (e) {
      console.error("API响应解析失败:", e);
      throw new Error("API响应解析失败: " + responseText.substring(0, 100));
    }
    
    // 打印API返回的完整数据以便调试
    console.log("API返回的解析数据:", data);
    
    if (!response.ok) {
      if (data && data.error) {
        console.error("API返回错误:", data.error);
        throw new Error(`API错误: ${data.error.message || JSON.stringify(data.error)}`);
      }
      throw new Error(`API请求失败: ${response.status} ${response.statusText}`);
    }
    
    // 安全检查返回数据格式
    if (!data || !data.choices || !Array.isArray(data.choices) || data.choices.length === 0) {
      console.error("API返回数据格式不正确:", data);
      throw new Error("API返回的数据格式异常");
    }
    
    // 尝试不同的访问路径
    let enhancedText;
    
    if (data.choices[0].message && data.choices[0].message.content) {
      // 标准OpenAI格式
      enhancedText = data.choices[0].message.content;
    } else if (data.choices[0].text) {
      // 一些老版本API使用这种格式
      enhancedText = data.choices[0].text;
    } else if (typeof data.choices[0] === 'string') {
      // 极少数API可能直接返回字符串
      enhancedText = data.choices[0];
    } else {
      // 如果都无法获取，尝试找出任何可能是文本的字段
      console.warn("无法解析标准响应格式，尝试查找任何文本字段");
      
      const firstChoice = data.choices[0];
      console.log("首个选择对象:", firstChoice);
      
      // 递归查找任何可能是文本内容的字段
      const findTextContent = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        
        // 检查常见的内容字段名
        for (const key of ['content', 'text', 'value', 'message']) {
          if (typeof obj[key] === 'string' && obj[key].length > 0) {
            return obj[key];
          } else if (obj[key] && typeof obj[key] === 'object' && typeof obj[key].content === 'string') {
            return obj[key].content;
          }
        }
        
        // 递归检查所有字段
        for (const key in obj) {
          if (typeof obj[key] === 'object') {
            const result = findTextContent(obj[key]);
            if (result) return result;
          } else if (typeof obj[key] === 'string' && obj[key].length > 10) {
            // 任何看起来像内容的较长字符串
            return obj[key];
          }
        }
        
        return null;
      };
      
      enhancedText = findTextContent(firstChoice) || text;
    }
    
    // 如果润色后的文本比原文短很多，可能是模型出现了问题，拒绝该结果
    if (enhancedText.length < text.length * 0.9 && text.length > 10) {
      console.warn("润色后文本长度减少，可能丢失了信息，使用原文");
      enhancedText = text;
    }
    
    // 确保短文本有足够的增强
    if (text.length < 50 && enhancedText.length < text.length * 1.5) {
      console.warn("短文本润色后扩展不足，可能效果不佳，使用原文");
      enhancedText = text;
    }
    
    console.log("最终提取的润色文本:", enhancedText);
    
    return {
      success: true,
      data: enhancedText,
      error: null
    };
  } catch (error) {
    console.error("文本润色API调用失败:", error);
    return {
      success: false,
      data: text, // 发生错误时返回原始文本
      error: error.message || "文本润色失败，请稍后再试"
    };
  }
};

export default enhanceText; 